import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/admin/usuarios',
    name: 'users.index',
    component: () => import('./views/UsersIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'users.read',
      breadcrumb: 'Usuarios',
    },
  },
]

export default routes
